module.exports = __webpack_public_path__ + "media/map/TX_Icon-0d07313d.png";